export default __webpack_public_path__ + "static/media/infomir.82846567.jpg";